import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllSuppliers } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useForceDeleteAllSuppliers = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllSuppliersMutate, isPending } = useMutation({
        mutationFn: forceDeleteAllSuppliers,
        onSuccess: (res) => {
            toast.success(res.message || "All suppliers force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to force delete suppliers");
        },
    });

    return { forceDeleteAllSuppliersMutate, isPending };
};

export default useForceDeleteAllSuppliers;
